/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { Animate, CosmosAsset, OptimizedCosmosAssetFragment } from "@components/elements";
import { css } from "@panda/css";
import { VStack } from "@panda/jsx";

export interface HeroAlphaHeroImageProps {
	heroAsset?: OptimizedCosmosAssetFragment | null;
}

const wrapperStyles = css({
	position: "absolute",
	right: "0",
	top: "50%",
	transform: "translateY(-50%)",
	transition: "none",
	lgDown: {
		position: "relative",
		top: "initial",
		right: "initial",
		transform: "initial",
	},
});

const assetStyles = css({
	width: "978px",
	aspectRatio: "16 / 9",

	lgOnly: {
		width: "817px",
	},
	lgDown: {
		width: "100%",
		marginBlockStart: "64px",
	},

	"& img, video": {
		borderRadius: "eds.borderRadius.32",
		minHeight: "100%",
		width: "100%",
		objectFit: "cover",
	},
});

export const HeroAlphaHeroImage = ({ heroAsset }: HeroAlphaHeroImageProps): React.JSX.Element => {
	return (
		<VStack
			justifyContent="center"
			alignItems="flex-end"
			height="100%"
			width="auto"
			className={`hero-alpha-hero-image ${wrapperStyles}`}
		>
			<Animate delay={0.5} type="slideLeft">
				<div className={`cosmos-asset ${assetStyles}`}>
					<CosmosAsset asset={heroAsset} eager />
				</div>
			</Animate>
		</VStack>
	);
};
